module.exports = __webpack_public_path__ + "static/media/serieTHL.5adaafc1.jpg";